import React, {useEffect, useState} from 'react';
import Header from "../Header";
import Footer from "../Footer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sendRequestQuduq} from "../../api/request";
import ModalQidirish from "./ModalQidirish";
import {NavLink} from "react-router-dom";
import {ExcelPrint, Pdf} from "../../units/Print";

const Dayver = () => {
    const dateNow = new Date()
    const year = dateNow.getFullYear()
    let month = dateNow.getMonth() + 1
    let day = dateNow.getDate()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    const today = `${day}.${month}.${year}`

    const [loading, setLoading] = useState(false)
    const [active, setActive] = useState(false)
    const [statics, setStatics] = useState({})
    const [pudratchi, setPudratchi] = useState([])
    const [hisobot, setHisobot] = useState([])

    useEffect(() => {
        const GetStatistics = async () => {
            try {
                await sendRequestQuduq({
                    url: "statistika",
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setStatics(res.data[0])
                });
            } catch (e) {
                console.log(e)
            }
        }
        GetStatistics()
    }, []);

    useEffect(() => {
        const GetPudratchi = async () => {
            try {
                await sendRequestQuduq({
                    url: "pudratchi",
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setPudratchi(res.data)
                });
            } catch (e) {
                console.log(e)
            }
        }
        GetPudratchi()
    }, []);

    useEffect(() => {
        const GetHisobot = async () => {
            try {
                await sendRequestQuduq({
                    url: "hisobot",
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setHisobot(res.data)
                });
            } catch (e) {
                console.log(e)
            }
        }
        GetHisobot()
    }, []);

    const filterHandler = (arg) => {
        const GetHisobotTib = async () => {
            try {
                await sendRequestQuduq({
                    url: `hisobot-tib?arg=${arg}`,
                    method: "GET",
                }).then((res) => {
                    if (res) setLoading(true)
                    setHisobot(res.data)
                });
            } catch (e) {
                console.log(e)
            }
        }
        GetHisobotTib()
    }

    const ReGetHisobot = async () => {
        try {
            await sendRequestQuduq({
                url: "hisobot",
                method: "GET",
            }).then((res) => {
                if (res) setLoading(true)
                setHisobot(res.data)
            });
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <>
            <Header />
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-sm-6 col-12">
                        <div className="card mt-3 mt-md-5 p-2">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon color="green" icon="fa-solid fa-sitemap" className="me-2" /> <strong>Jami integratsiya: {statics?.integratsiya} ta</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                        <div className="card mt-3 mt-md-5 p-2">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon color="red" icon="fa-solid fa-bug" className="me-2" /> <strong>Xatoliklar: {statics?.xato} ta</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                        <div className="card mt-3 mt-md-5 p-2">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon color="blue" icon="fa-solid fa-handshake" className="me-2" /> <strong>Pudratchilar: {statics?.pudratchi} ta</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                        <div className="card mt-3 mt-md-5 p-2">
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon color="#fcba03" icon="fa-solid fa-hashtag" className="me-2" /> <strong>Reja 21-25: -- ta</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt-4 mt-sm-4 _container">
                <div className="card py-3 mb-0" style={{backgroundColor: "#cfe2ff"}}>
                    <h3 className="text-center" style={{maxWidth: "1200px", marginLeft: "auto", marginRight: "auto"}}>2021-2025-yillarda o‘rnatilgan "Dayver" qurilmalari to‘g‘risida tezkor ma'lumot</h3>
                </div>
                <div className="row mt-4 mt-sm-4">
                    <div className="col-md-12 col-lg-8">
                        <div className="card d-block p-2 mb-3">
                            {
                                active ?
                                    <button onClick={() => (ReGetHisobot(), setActive(false))} className=" mt-2 mt-sm-0 btn btn-outline-primary py-0 ms-2 active"><FontAwesomeIcon icon="fa-solid fa-left-long" /></button>
                                    : ''
                            }
                            <button className=" mt-2 mt-sm-0 btn btn-outline-primary py-0 ms-2 active"><FontAwesomeIcon icon="fa-regular fa-calendar" /> 21-25</button>
                            {/*<button className=" mt-2 mt-sm-0 btn btn-outline-primary py-0 ms-2"><FontAwesomeIcon icon="fa-regular fa-calendar" /> 2021</button>*/}
                            {/*<button className=" mt-2 mt-sm-0 btn btn-outline-primary py-0 ms-2"><FontAwesomeIcon icon="fa-regular fa-calendar" /> 2022</button>*/}
                            {/*<button className=" mt-2 mt-sm-0 btn btn-outline-primary py-0 ms-2"><FontAwesomeIcon icon="fa-regular fa-calendar" /> 2023</button>*/}
                            <NavLink to="/dayver/monitoring" className="mt-2 mt-sm-0 btn btn-warning py-0 ms-2"><FontAwesomeIcon icon="fa-solid fa-tv" /> Monitoring</NavLink>
                            <NavLink to="/dayver/dayver-jadval" className="mt-2 mt-sm-0 btn btn-info py-0 ms-2"><FontAwesomeIcon icon="fa-solid fa-check-double" /> Barchasi</NavLink>
                            <button
                                onClick={() => Pdf('tblData', false, 'Integratsiya (dayver)')}
                                className=" mt-2 mt-sm-0 btn btn-danger py-0 ms-2">
                                <FontAwesomeIcon icon="fa-solid fa-file-pdf" /> Pdf
                            </button>
                            <button
                                onClick={()=>ExcelPrint("Integratsiya (dayver)", "dayver","tblData")}
                                className=" mt-2 mt-sm-0 btn btn-success py-0 ms-2">
                                <FontAwesomeIcon icon="fa-solid fa-file-excel" /> Excel
                            </button>
                        </div>
                        <div className="table-responsive ">
                            <table data-cols-width="5,25, 17, 17, 7, 17, 7, 17, 7" className="table table-bordered table-hover text-center" id="tblData">
                                <thead className="table-primary align-middle ">
                                <tr data-height="50" style={{height: "80px", display: "none"}}>
                                    <th style={{backgroundColor: "#fff", border: "none"}} colSpan={2}></th>
                                    <th
                                        style={{backgroundColor: "#fff", border: "none"}}
                                        colSpan={5}
                                        data-a-v="middle"
                                        data-a-h="center"
                                        data-f-bold="true"
                                        data-a-wrap="true"
                                        scope="col">
                                        2021-2025-yillarda integratsiya qilingan "Dayver" qurilmalari to‘g‘risida MA'LUMOT
                                    </th>
                                    <th style={{backgroundColor: "#fff", border: "none"}} colSpan={2}></th>
                                </tr>
                                <tr style={{display: "none"}}>
                                    <th data-a-h="right" data-f-italic="true" colSpan={9} scope="col">holat: {today}</th>
                                </tr>
                                <tr data-height="22">
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" rowSpan={2} scope="col">T/r</th>
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" rowSpan={2} scope="col">Hududlar nomi</th>
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-a-wrap="true" data-b-a-s="thin" data-a-h="center" data-f-bold="true" rowSpan={2} scope="col">Integratsiya qilingan qurilmalar soni (dona)</th>
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" colSpan={6} scope="col">Shundan</th>
                                </tr>
                                <tr data-height="100">
                                    <th data-fill-color="cfe2ff" data-a-wrap="true" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" scope="col">Hozirgi kunda ma'lumot yuborayotgan qurilmalar soni (dona)</th>
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" scope="col">Foiz %</th>
                                    <th data-fill-color="cfe2ff" data-a-wrap="true" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" scope="col">Ma'lumot yuborishi to'xtab qolgan qurilmalar soni (dona)</th>
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" scope="col">Foiz %</th>
                                    <th data-fill-color="cfe2ff" data-a-wrap="true" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" scope="col">Hozirga qadar mutlaqo ma'lumot yubormagan qurilmalar soni (dona)</th>
                                    <th data-fill-color="cfe2ff" data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" scope="col">Foiz %</th>
                                </tr>
                                </thead>
                                <tbody className="align-middle">
                                {
                                    loading ?
                                        hisobot.map((item, index) => {
                                            return (
                                                index != hisobot.length - 1 ?
                                                    <tr data-height="20" key={index}>
                                                        <th data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n" scope="row">{index + 1}</th>
                                                        <td data-a-indent="0,9" data-a-v="middle" data-b-a-s="thin" data-f-bold="true" onClick={() => (filterHandler(item.region), setActive(true))} className="text-nowrap text-start click-text">{item.vil_nomi}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.int_soni}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.mal_kelgan}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.foiz1}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.uzulsh_bor}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.foiz2}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.mal_kelmagan}</td>
                                                        <td data-a-v="middle" data-b-a-s="thin" data-a-h="center" data-t="n">{item.foiz3}</td>
                                                    </tr> :
                                                    <tr data-height="22" key={index} className="fw-bold">
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" colSpan={2}>{item.vil_nomi}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.int_soni}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.mal_kelgan}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.foiz1}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.uzulsh_bor}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.foiz2}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.mal_kelmagan}</td>
                                                        <td data-a-v="middle" data-fill-color="d8e0e6" data-b-a-s="thin" data-a-h="center" data-f-bold="true" data-t="n">{item.foiz3}</td>
                                                    </tr>
                                            )
                                        }) : <tr><td>Yuklanmoqda</td></tr>
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4">
                        <div className="card mt-3 mt-lg-0">
                            <div className="card-header " style={{backgroundColor: "#cfe2ff"}}>
                                <p className="text-center m-0"><strong>Qurilmani KOD yoki IMEI orqali tekshirish</strong></p>
                            </div>
                            <ul className="list-group list-group-flush">
                                <li key={1} className="list-group-item text-center my-4">
                                    <button className="btn btn-primary px-4" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Qidirish</button>
                                </li>
                            </ul>
                        </div>
                        <div className="card mt-4">
                            <div className="card-header " style={{backgroundColor: "#cfe2ff"}}>
                                <p className="text-center m-0"><strong>Dayver qurulmalarini o'rnatgan pudratchilar</strong></p>
                            </div>
                            <ul className="list-group list-group-flush list-pud">
                                <li key={1} className="list-group-item p-1">
                                    <table className="table table-bordered table-hover m-0 text-center">
                                        <tbody>
                                        {
                                            loading ?
                                                pudratchi.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th style={{width: "30px"}} scope="row">{index+1}</th>
                                                            <td className="text-start">{item.company}</td>
                                                            <td style={{width: "50px"}}>{item.int_soni}</td>
                                                        </tr>
                                                    )
                                                }) : <tr><td>Yuklanmoqda</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <ModalQidirish />
            <Footer />
        </>
    );
};

export default Dayver;